import { Component, Inject, ContentChildren, AfterContentInit, AfterViewChecked, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output, QueryList, SimpleChanges, ViewChild, ViewEncapsulation, Renderer2, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { MenuItem } from '../menu-item/menu-item.components';
import { Router } from '@angular/router';

@Component({
	selector: 'kt-aside-left',
	templateUrl: './aside-left.component.html',
	styleUrls: ['./aside-left.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class AsideLeftComponent implements OnInit, AfterContentInit, OnChanges, AfterViewChecked {
	@ContentChildren(MenuItem) items: QueryList<MenuItem>;
	toggled: Record<string, boolean> = {};
	subToggled: Record<string, Record<string, boolean>> = {};
	@Input() expendBar: boolean;
	@Output() expendBarChange = new EventEmitter<boolean>();
	@ViewChild('mobileClose') mobileClose: ElementRef<HTMLButtonElement>;
	private focusMobileMenu = false;
	expanded: boolean = true;
	mobileMode = false;

	constructor(@Inject(DOCUMENT) private document: Document, public router: Router, private renderer: Renderer2) { }
	
	ngOnInit(): void {
		this.mobileMode = !!this.document.defaultView?.matchMedia('(max-width: 1024px)').matches;
		this.maximize();
	}

	ngAfterContentInit(): void {
		for (const item of this.items)
			this.subToggled[item.title] = {};
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.expendBar?.currentValue) this.focusMobileMenu = true;
	}

	ngAfterViewChecked(): void {
		if (this.focusMobileMenu) {
			this.focusMobileMenu = false;
			const close = this.mobileClose?.nativeElement;
			if (close?.getClientRects().length) close.focus();
		}
	}

	closeMobile(): void {
		if (!this.expendBar) return;
		this.expendBar = false;
		this.expendBarChange.emit(false);
		this.document.getElementById('kt_aside_mobile_toggler')?.focus();
	}

	onEscape(event: Event): void {
		if (this.expendBar) {
			event.stopPropagation();
			this.closeMobile();
		}
	}

	@HostListener('window:resize') onResize(): void {
		this.mobileMode = !!this.document.defaultView?.matchMedia('(max-width: 1024px)').matches;
		if (this.expendBar && !this.mobileMode) this.closeMobile();
	}

	stickAside() {
		this.expanded ? this.minimize() : this.maximize();
	}

	maximize() {
		this.expanded = true;
		this.renderer.removeClass(this.document.body, 'kt-aside--minimize');
		this.renderer.addClass(this.document.body, 'kt-aside--minimizing');
	}
	
	minimize() {
		this.expanded = false;
		this.renderer.removeClass(this.document.body, 'kt-aside--minimizing');
		this.renderer.addClass(this.document.body, 'kt-aside--minimize');
	}

	toggle(selected: MenuItem) {
		for (const item of Object.keys(this.toggled)) {
			if (item !== selected.title)
				this.toggled[item] = false;
		}
		this.toggled[selected.title] = !this.toggled[selected.title];
	}

	subToggle(main: MenuItem, selected: MenuItem) {
		const toggled = this.subToggled[main.title] ||= {};
		for (const item of Object.keys(toggled)) {
			if (item !== selected.title)
				toggled[item] = false;
		}
		toggled[selected.title] = !toggled[selected.title];
	}

	hasUrl(item: MenuItem) {
		return item.subItems.find(sub => sub.url === this.router.url) ||
			item.subItems.find(sub => sub.subItems.find(sub2 => sub2.url === this.router.url));
	}
}
